export default __webpack_public_path__ + "static/media/metadyn.396ec4bd.png";